export const trendSeries = [{
   name: "A",
   data: [200, 400, 600, 700, 800, 1000, 1200, 1400, 1600]
 }, {
   name: "B",
   data: [300, 600, 800, 1200, 1400, 1600, 2000, 1600]
 }, {
   name: "C",
   data: [2000, 100, 700, 300, 200, 888, 999, 234, 1600]
 }, {
   name: "D",
   data: [300, 600, 800, 1200, 1400, 1600, 2000, 1600]
 }];
